var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 48C20.4162 48 24.0002 44.4159 24.0002 39.9999V31.9999H16.0001C11.5841 31.9999 8 35.5839 8 39.9999C8 44.4159 11.5841 48 16.0001 48Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 23.9999C8 19.5839 11.5841 15.9999 16.0001 15.9999H24.0002V31.9998H16.0001C11.5841 32 8 28.4159 8 23.9999Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.00006C8 3.58406 11.5841 0 16.0001 0H24.0002V15.9999H16.0001C11.5841 15.9999 8 12.4161 8 8.00006Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0H31.9999C36.4159 0 40 3.58406 40 8.00006C40 12.4161 36.4159 15.9999 31.9999 15.9999H23.9998V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23.9999C40 28.4159 36.4159 32 31.9999 32C27.5838 32 23.9998 28.4159 23.9998 23.9999C23.9998 19.5839 27.5838 15.9999 31.9999 15.9999C36.4159 15.9999 40 19.5839 40 23.9999Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaOriginal);
export default __webpack_public_path__ + "static/media/Figma - Original.4345f9fe97f8b4d96ae9f17a62cb5bd7.svg";
export { ForwardRef as ReactComponent };